import React from "react";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { removeHtmlTags } from "utils/Utils";
import styles from "./styles.module.scss";

import { customTableStylesReport, fallbackIfEmpty } from "utils/Utils";

const Table = ({ dados, loading, actionFilter, totalRecords }) => {
  const columns = [
    {
      name: "Treinamento",
      selector: "Treinamento",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d.Treinamento),
    },
    {
      name: "Modalidade",
      selector: "Modalidade",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d.Modalidade),
    },

    {
      name: "Turma",
      selector: "Turma",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d.Turma),
    },

    {
      name: "Nome do gestor",
      selector: "Nome do gestor",
      sortable: true,
      center: true,
      wrap: true,
      width: "200px",
      style: {
        textAlign: "center",
        justifyContent: "center",
        whiteSpace: "normal",
        overflow: "visible",
        textOverflow: "unset",
        wordBreak: "break-word",
      },
      cell: (d) => (
        <span
          style={{
            textAlign: "center",
            justifyContent: "center",
            whiteSpace: "normal",
            overflow: "visible",
            textOverflow: "unset",
            wordBreak: "break-word",
          }}
        >
          {fallbackIfEmpty(d["Nome do gestor"])}
        </span>
      ),
    },
    {
      name: "E-mail do gestor",
      selector: "E-mail do gestor",
      sortable: true,
      center: true,
      wrap: true,
      width: "280px",
      style: {
        textAlign: "center",
        justifyContent: "center",
        whiteSpace: "normal",
        overflow: "visible",
        textOverflow: "unset",
        wordBreak: "break-word",
      },
      cell: (d) => (
        <span
          style={{
            textAlign: "center",
            justifyContent: "center",
            whiteSpace: "normal",
            overflow: "visible",
            textOverflow: "unset",
            wordBreak: "break-word",
          }}
        >
          {fallbackIfEmpty(d["E-mail do gestor"])}
        </span>
      ),
    },
    {
      name: "Empresa",
      selector: "Empresa",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d.Empresa),
    },
    {
      name: "Cargo do Gestor",
      selector: "Cargo do Gestor",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["Cargo do Gestor"]),
    },
    {
      name: "Usuário (aluno)",
      selector: "Usuário (aluno)",
      sortable: true,
      center: true,
      wrap: true,
      width: "200px",
      style: {
        textAlign: "center",
        justifyContent: "center",
        whiteSpace: "normal",
        overflow: "visible",
        textOverflow: "unset",
        wordBreak: "break-word",
      },
      cell: (d) => (
        <span
          style={{
            textAlign: "center",
            justifyContent: "center",
            whiteSpace: "normal",
            overflow: "visible",
            textOverflow: "unset",
            wordBreak: "break-word",
          }}
        >
          {fallbackIfEmpty(d["Usuário (aluno)"])}
        </span>
      ),
    },
    {
      name: "Cargo do aluno",
      selector: "Cargo do aluno",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["Cargo do aluno"]),
    },
    {
      name: "Departamento",
      selector: "Departamento",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["Departamento"]),
    },
    {
      name: "Unidade",
      selector: "Unidade",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["Unidade"]),
    },
    {
      name: "Avaliação",
      selector: "Avaliação",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["Avaliação"]),
    },
    {
      name: "Tipo da questão",
      selector: "Tipo da questão",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["Tipo da questão"]),
    },
    {
      name: "Questão",
      selector: "Questão",
      sortable: true,
      center: true,
      wrap: true,
      width: "400px",
      style: {
        textAlign: "center",
        justifyContent: "center",
        whiteSpace: "normal",
        overflow: "visible",
        textOverflow: "unset",
        wordBreak: "break-word",
      },
      cell: (d) => (
        <span
          style={{
            textAlign: "center",
            justifyContent: "center",
            whiteSpace: "normal",
            overflow: "visible",
            textOverflow: "unset",
            wordBreak: "break-word",
          }}
        >
          {d["Questão"] ? removeHtmlTags(d["Questão"], true) : "-"}
        </span>
      ),
    },
    {
      name: "Resposta",
      selector: "Resposta",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: (d) => <>{d.Resposta ? removeHtmlTags(d.Resposta, true) : "-"}</>,
    },
    {
      name: "Data de disponibilização",
      selector: "Data de disponibilização",
      sortable: true,
      center: true,
      wrap: true,
      style: {
        whiteSpace: "nowrap",
      },
      cell: (d) => (
        <span style={{ whiteSpace: "nowrap" }}>
          {fallbackIfEmpty(d["Data de disponibilização"])}
        </span>
      ),
    },
    {
      name: "Prazo para finalização",
      selector: "Prazo para finalização",
      sortable: true,
      center: true,
      wrap: true,
      style: {
        whiteSpace: "nowrap",
      },
      cell: (d) => (
        <span style={{ whiteSpace: "nowrap" }}>{fallbackIfEmpty(d["Prazo para finalização"])}</span>
      ),
    },
    {
      name: "Status da avaliação",
      selector: "Status da avaliação",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["Status da avaliação"]),
    },
    {
      name: "Data de finalização",
      selector: "Data de finalização",
      sortable: true,
      center: true,
      wrap: true,
      style: {
        whiteSpace: "nowrap",
      },
      cell: (d) => (
        <span style={{ whiteSpace: "nowrap" }}>{fallbackIfEmpty(d["Data de finalização"])}</span>
      ),
    },
  ];

  // const customTableStyles = {
  //   table: {
  //     style: {
  //       tableLayout: "auto", // permite largura dinâmica das colunas
  //     },
  //   },
  //   cells: {
  //     // center: true,
  //     style: {
  //       textAlign: "center",
  //       justifyContent: "center",
  //       whiteSpace: "normal", // permite quebra de linha
  //       overflow: "visible",
  //       textOverflow: "unset",
  //       wordBreak: "break-word",
  //       width: "150px",
  //     },
  //   },
  //   headCells: {
  //     // center: true,
  //     style: {
  //       textAlign: "center",
  //       justifyContent: "center",
  //       whiteSpace: "normal",
  //       fontWeight: "bold",
  //       position: "relative", // necessário para que o sortable fique absoluto em relação ao th
  //       padding: "0 0 0 12px", // espaço pro ícone
  //     },
  //   },
  //   sortIcon: {
  //     style: {
  //       position: "absolute",
  //       top: "50%",
  //       right: "8px",
  //       transform: "translateY(-50%)",
  //       pointerEvents: "none", // opcional, evita que o clique no ícone interfira
  //     },
  //   },
  // };

  const tableData = {
    columns: columns,
    data: dados,
  };

  const paginationComponentOptions = {
    rowsPerPageText: "Questões por página",
    rangeSeparatorText: "de",
  };

  const onChangePage = (page, totalRows) => {
    actionFilter({ offset: --page * dados.length });
  };

  const onChangeRowsPerPage = (limit) => {
    actionFilter({ limit, offset: 0 });
  };

  const loadingComponent = () => {
    return (
      <div className="tela-login-loading">
        <div className="loader-container" style={{ margin: "300px 0" }}>
          <div
            style={{
              position: "initial",
              margin: "initial",
            }}
            className="loader loader-center loader-big"
          ></div>
          <span
            style={{
              marginTop: 10,
              fontSize: 20,
            }}
          >
            Carregando dados...
          </span>
        </div>
      </div>
    );
  };

  return (
    <DataTableExtensions
      filter={false}
      print={false}
      {...tableData}
      exportHeaders={false}
      export={false}
    >
      <DataTable
        columns={columns}
        data={dados}
        className={styles.dataTableFormat}
        customStyles={customTableStylesReport}
        progressPending={loading}
        progressComponent={loadingComponent()}
        noHeader={true}
        noDataComponent="Não foi encontrado nenhum dado"
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
        paginationTotalRows={totalRecords}
        paginationComponentOptions={paginationComponentOptions}
        paginationServer
        pagination
      />
    </DataTableExtensions>
  );
};

export default Table;
